module.exports = __webpack_public_path__ + "img/ico20.c4d4c324.jpg";